"use strict";

module.exports = ['IP_src', 'IP_dst', 'TopFlowsIP', 'src_nexthop_ip', 'dst_nexthop_ip'];